if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Declaration uploader
         * Functionality for uploading declarations
         *
         *
         *
         * @param form - jQuery object of containing (sub)form (not required to be of <form> element)
         */
        ZZ.SimpleDeclarationUploader = function(form) {
            var base = this;
            base.form = form;
            base.fileinputContainer = base.form.find(".custom-fileupload");
            base.fileinput = base.form.find("[type=file]");
            base.deleteBtn = base.form.find(".delete");
            base.fileName = base.form.find(".filename");
            base.fileBtn = base.fileinputContainer.find("span");

            var fileTypesDefault = [
                "jpg",
                "png",
                "xls",
                "xlsx",
                "doc",
                "docx",
                "pdf",
                "tiff",
                "tif"
            ];
            base.fileTypes = base.fileinput.attr("data-filetypes");

            if (base.fileTypes === undefined) {
                base.fileTypes = fileTypesDefault;
            } else {
                base.fileTypes = base.fileTypes
                    .replace(/([\[-\]-\''])/g, "")
                    .split(",");
            }

            base.fileBtn.show();
            base.fileinputContainer.addClass("btn");

            base.FileApiSupported = !!(
                window.File &&
                window.FileReader &&
                window.FileList &&
                window.Blob
            );
            base.fileSize = 0;

            base.submitBtn = base.form.find("[type=submit]");

            base.result = base.form.find(".result");

            base.validationMessage = base.form.find(".validation-message");

            base.sizeValidationMessage = base.form.find(
                ".size-validation-message"
            );

            base.initFileUploader();
            base.assignListeners();

            return base;
        };

        ZZ.SimpleDeclarationUploader.prototype = {
            initFileUploader: function() {
                var base = this;
                base.result.hide();
            },

            assignListeners: function() {
                var base = this;
                base.fileinput.on("change", base.showChosenfile.bind(base));
                base.deleteBtn.on("click", base.removeChosenfile.bind(base));
                base.form.on("submit", base.formsubmit.bind(base));
            },

            showChosenfile: function() {
                var path = this.fileinput.val();
                var fileName = path.match(/[^\/\\]+$/);

                if (this.FileApiSupported) {
                    this.fileSize = this.checkFilesize(this.fileinput);
                }

                if (this.checkFileType(fileName[0])) {
                    this.fileBtn.hide();
                    this.fileinputContainer.toggleClass("btn");
                    this.result.show();
                    this.deleteBtn.show();
                    this.fileName.html(fileName[0]);
                    this.validationMessage.hide();
                    this.hideFileSizeError();
                    $(this.fileinputContainer).trigger(
                        "ZZ_file_chosen",
                        this.fileSize
                    );
                } else {
                    this.validationMessage.show();
                }
            },

            removeChosenfile: function(event) {
                event.preventDefault();
                this.result.hide();
                this.deleteBtn.hide();
                this.fileName.html("");
                this.fileBtn.show();
                this.fileinputContainer.toggleClass("btn");
                this.fileinput.val("");
                $(this.fileinputContainer).trigger(
                    "ZZ_file_removed",
                    this.fileSize
                );
            },

            checkFileType: function(file) {
                return (
                    $.inArray(
                        file
                            .split(".")
                            .pop()
                            .toLowerCase(),
                        this.fileTypes
                    ) > -1
                );
            },

            checkFilesize: function(fileInput) {
                var fileSize = fileInput[0].files[0].size; //size in kb
                fileSize = fileSize / 1048576; //size in mb
                return fileSize;
            },

            showFileSizeError: function() {
                this.sizeValidationMessage.show();
            },

            hideFileSizeError: function() {
                this.sizeValidationMessage.hide();
            },

            formsubmit: function(event) {
                this.submitBtn.attr("disabled", "disabled");
            }
        };
    })(jQuery);
}
